import {
  ListItemButtonProps,
  ListItemButton as MUIListItemButton,
  styled,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { LinkProps } from "react-router";

import styles from "./styles.module.css";

const ListItemButton = styled(MUIListItemButton)(({ theme }) => ({
  flexDirection: "column",
  padding: "0",
  backgroundColor: theme.palette.custom.light,
  borderRadius: "8px",
  ":not(:last-child)": {
    marginBottom: "8px",
  },
  "&:hover": {
    backgroundColor: theme.palette.custom.light,
  },
  [theme.breakpoints.up("md")]: {
    backgroundColor: "transparent",
  },
}));

type LinkItemProps = ListItemButtonProps & LinkProps;

interface IProps extends LinkItemProps {
  withDivider?: boolean;
  children: React.ReactNode;
}

const StyledListItemLink = observer(
  ({ withDivider, children, ...restProps }: IProps) => {
    return (
      <ListItemButton {...restProps}>
        {children}
        {withDivider && <div className={styles.divider} />}
      </ListItemButton>
    );
  }
);

export default StyledListItemLink;
